export const INTERVIEWER_TYPE = {
    IV_EXPERTS:"INTERVIEWVECTOR",
    CLIENT_INTERNAL:"CLIENT_INTERNAL",
}